var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { C } from '#integrations';
import { StrongTestIdFactory } from './interactions';
import styles from './Strong.module.css';
const COLOR_CLASS_MAP = {
    accent: styles.AccentColor,
    default: styles.DefaultColor,
    alert: styles.AlertColor,
    positive: styles.PositiveColor,
    negative: styles.NegativeColor,
    informative: styles.InformativeColor,
    inherit: styles.InheritColor,
    inverted: styles.InvertedColor,
};
/**
 * As Strong is being used to alter the text
 * content it makes sense to be able to
 * alter the text break behavior.
 * We need this because in wordings where we use
 * Strong we have combination of text elements and the strong
 * making it hard to align the text in acceptable manner.
 */
const WORD_BREAK_CLASS_MAP = {
    breakAll: styles.BreakAll,
    breakWord: styles.BreakWord,
    normal: undefined,
};
export const Strong = ({ children, className, color = 'inherit', 'data-testid': testId, title, wordBreak = 'normal', }) => {
    return (_jsx("strong", { className: C(styles.Container, WORD_BREAK_CLASS_MAP[wordBreak], COLOR_CLASS_MAP[color], className), ...(testId && {
            'data-testid': StrongTestIdFactory.getStrongTestId(testId),
        }), ...(title ? { title } : {}), children: children }));
};
_react_refresh_temp_1 = Strong;
$RefreshReg$(_react_refresh_temp_1, "Strong");
